import { useEffect } from "react";

const Toast = ({ type = "info", message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const styles = {
    success: {
      background: "#4CAF50",
    },
    error: {
      background: "#F44336",
    },
    warning: {
      background: "#FF9800",
    },
    info: {
      background: "#2196F3",
    },
  };

  return (
    <div style={{ ...toastStyle, ...styles[type] }}>
      <span>{message}</span>
      <button style={closeBtn} onClick={onClose}>
        ✕
      </button>
    </div>
  );
}

const toastStyle = {
  position: "fixed",
  top: "20px",
  right: "20px",
  color: "#fff",
  padding: "14px 18px",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  zIndex: 9999,
  minWidth: "260px",
  fontWeight: 500,
};

const closeBtn = {
  background: "transparent",
  border: "none",
  color: "#fff",
  fontSize: "16px",
  cursor: "pointer",
};

export { Toast };